module.exports = "/_next/static/images/award-Telkom-20eb2076c59fb646f4761aeab5271469.png";